import NewPuzzleSettings from './NewPuzzleSettings';

export default NewPuzzleSettings;
